export default __webpack_public_path__ + "media/images/landing-10-550x420-f85d97e7fdd5d3f57c0132a61b98dae1.jpg";